module.exports = __webpack_public_path__ + "static/img/360aq_img_4.59357017.png";